import { useTranslations } from 'next-intl';
import { CustomImage as Image } from '..';
import styles from './ExpertSection.module.css';

const ExpertsData = [
  [
    {
      img: 'web_v2/rare/features-v3/sleep.png',
      img_resp: 'web_v2/rare/features/sleep_resp.png',
      titleKey: 'ring.rare.expert.sleep.title',
      descriptionKey: 'ring.rare.expert.sleep.description',
    },
    {
      img: 'web_v2/rare/features-v3/recovery.png',
      img_resp: 'web_v2/rare/features/recovery_resp.png',
      titleKey: 'ring.rare.expert.recovery.title',
      descriptionKey: 'ring.rare.expert.recovery.description',
    },
  ],
  [
    {
      img: 'web_v2/rare/features-v3/movement.png',
      img_resp: 'web_v2/rare/features/movement_resp.png',
      titleKey: 'ring.rare.expert.movement.title',
      descriptionKey: 'ring.rare.expert.movement.description',
    },
    {
      img: 'web_v2/rare/features-v3/stress.png',
      img_resp: 'web_v2/rare/features/stress_Resp.png',
      titleKey: 'ring.rare.expert.stress.title',
      descriptionKey: 'ring.rare.expert.stress.description',
    },
  ],
  [
    {
      img: 'web_v2/rare/features-v3/womens.png',
      img_resp: 'web_v2/rare/features/women_resp.png',
      titleKey: 'ring.rare.expert.womensHealth.title',
      descriptionKey: 'ring.rare.expert.womensHealth.description',
    },
    {
      img: 'web_v2/rare/features-v3/caffine.png',
      img_resp: 'web_v2/rare/features/caffeine_resp.png',
      titleKey: 'ring.rare.expert.caffeine.title',
      descriptionKey: 'ring.rare.expert.caffeine.description',
    },
  ],
];

export const ExpertSection = ({
  htmlId,
  isPricingPage,
}: {
  htmlId?: string;
  isPricingPage?: boolean;
}) => {
  const t = useTranslations('ring');

  return (
    <section className={styles.root} id={htmlId}>
        <div className="expert-content">
          {isPricingPage ? (
            <h2 className="head-pricing">
              {t('ring.rare.expert.headPricing')}
            </h2>
          ) : (
            <h2 className="head">
              {t.rich('ring.rare.expert.head', { br: () => <br /> })}
            </h2>
          )}
          {ExpertsData.map((row, index) => {
            return (
              <div className="row" key={index}>
                {row.map((expert, index) => {
                  return (
                    <div className="card" key={expert.titleKey + index}>
                      {/* Both variants rendered; CSS media query picks one so SSR paints correctly */}
                      <div className="img-container">
                        <Image
                          className="img-desktop"
                          width="1153"
                          height="909"
                          src={expert.img}
                          alt={expert.img}
                        />
                        <Image
                          className="img-mobile"
                          width="355"
                          height="462"
                          src={expert.img_resp}
                          alt={expert.img}
                        />
                      </div>
                      <div className="content">
                        <h4 className="title">{t(expert.titleKey)}</h4>
                        <p className="description">
                          {t(expert.descriptionKey)}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </section>
    );
};
